const Modal = {
    options: {
        elem: '[data-action="modal"]',
        closeButton: '#close-video-modal',
        contentContainer: '.modal-content',
        modalContainer: '#simple-modal-video'
    },

    init: function( customOptions ) {
        const   self         = this,
                modalButtons = document.querySelectorAll(self.options.elem);

        // Combine the custom options with the defaults
        self.options = { ...self.options, ...customOptions }

        // If the modal action button is on the page, add the modal HTML to the <body>
        if( modalButtons.length ) {
            self.addModalHtml();
        }

        // Set up event listeners
        self.initListeners(modalButtons);        
    },

    initListeners: function(modalButtons) {
        const self = this;
        const closeButton = document.querySelector(self.options.closeButton);

        // Open modal window
        modalButtons.forEach( button => {
            button.addEventListener('click', (e) => {
                self.prepareModalWindowContent(e.target.dataset);
                self.openModalWindow();
            })
        })

        // Close modal window
        if( closeButton !== null ) {
            closeButton.addEventListener('click', function(e) {
                document.querySelector(self.options.modalContainer).classList.remove('scale-100');
                setTimeout(function() {
                    self.removeModalContent();
                }, 200);
            })
        }


    },

    openModalWindow: function( data ) {
        const self = this;

        document.querySelector(self.options.modalContainer).classList.add('scale-100');
    },

    prepareModalWindowContent: function( data ) {
        const self = this;

        if( data.modalType === 'video' ) {
            self.loadVideoIntoContent(data.video);
        }  
    },

    addModalHtml: function() {
        const self = this;
        const modalContainer = document.createElement('div');
        const modalHtml = `<div id="${self.options.modalContainer.replace('#', '')}" data-is-active="false"
            class="fixed top-0 z-50 left-0 w-screen h-screen flex items-center justify-center bg-grey bg-opacity-50 transform scale-0 transition-transform duration-300">
            <div class="bg-white w-4/5 h-auto p-12 shadow-2xl"> 
                <button id="${self.options.closeButton.replace('#', '')}" type="button" class="focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </button>
                <div id="${self.options.contentContainer.replace('#', '')}">
                    
                </div>
            </div>
        </div>`;
        modalContainer.innerHTML = modalHtml;

        document.body.appendChild(modalContainer);
    },

    removeModalContent: function() {
        const self = this;
        document.querySelector(self.options.contentContainer).innerHTML = '';
    },

    loadVideoIntoContent: function(videoId)  {
        const self = this;
        var vimeoEmbedCode = '<div class="relative h-0 w-full pb-56-5"><iframe class="w-full h-full absolute left-0 top-0" src="https://player.vimeo.com/video/' + videoId + '?title=0&byline=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>';
        var modalContent = document.querySelector(self.options.contentContainer);
        modalContent.innerHTML = vimeoEmbedCode;
    }
}

export default Modal;